import axios from "axios";

const ADMIN_API =
  process.env.REACT_APP_ADMIN_API ||
  "https://admin.thinkdigitalacademy.org/api";

/**
 * Laravel by_marker row: may use `pending` (unmarked with marker) + `marked`, and
 * `marker_code` for display. Normalizes to assigned (total with marker in scope),
 * marked, wip (= pending).
 */
function normalizeByMarkerRow(row) {
  if (!row || typeof row !== "object") return row;
  const pending = row.pending != null ? Number(row.pending) : null;
  const marked = row.marked != null ? Number(row.marked) : null;
  if (
    pending != null &&
    !Number.isNaN(pending) &&
    marked != null &&
    !Number.isNaN(marked)
  ) {
    return {
      ...row,
      assigned: pending + marked,
      marked,
      wip: pending
    };
  }
  return row;
}

/**
 * Normalizes Laravel GET /api/marker-portal-dashboard-funnel?year= JSON.
 * Aligns with MarkerPortalController: marks_pending (unmarked in scope),
 * available/assigned splits, by_marker pending+marked, by_content_type from directory.
 */
export function normalizeFunnelPayload(raw) {
  if (!raw || typeof raw !== "object") return null;
  const n = x =>
    x != null && x !== "" && !Number.isNaN(Number(x)) ? Number(x) : null;
  const year = n(raw.year);
  const byMarker = Array.isArray(raw.by_marker)
    ? raw.by_marker.map(normalizeByMarkerRow)
    : [];
  return {
    year: year != null ? year : null,
    available: n(raw.available),
    assigned: n(raw.assigned),
    marked: n(raw.marked),
    marks_uploaded: n(raw.marks_uploaded),
    /** Unmarked uploads in assessment scope for year (Laravel: marks_pending). */
    marks_pending: n(raw.marks_pending),
    /** Optional: marked but not uploaded — not sent by current Laravel payload. */
    pending_marks_upload: n(raw.pending_marks_upload),
    median_days_to_mark: n(raw.median_days_to_mark),
    p90_days_to_mark: n(raw.p90_days_to_mark),
    stale_assigned_count: n(raw.stale_assigned_count),
    stale_assigned_days_threshold: n(raw.stale_assigned_days_threshold),
    by_marker: byMarker,
    by_content_type: Array.isArray(raw.by_content_type)
      ? raw.by_content_type
      : []
  };
}

export async function fetchAdminDashboardFunnel(year, bearerHeaders) {
  const url = `${ADMIN_API}/marker-portal-dashboard-funnel?year=${encodeURIComponent(
    year
  )}`;
  try {
    const res = await axios.get(url);
    return normalizeFunnelPayload(res.data);
  } catch {
    try {
      const res = await axios.get(url, { headers: bearerHeaders || {} });
      return normalizeFunnelPayload(res.data);
    } catch {
      return null;
    }
  }
}

export function funnelHasBackendData(funnel) {
  if (!funnel || typeof funnel !== "object") return false;
  const keys = [
    "median_days_to_mark",
    "p90_days_to_mark",
    "stale_assigned_count",
    "pending_marks_upload",
    "marks_pending",
    "marks_uploaded"
  ];
  if (keys.some(k => funnel[k] != null)) return true;
  if (funnel.by_marker && funnel.by_marker.length) return true;
  if (funnel.by_content_type && funnel.by_content_type.length) return true;
  if (
    funnel.available != null ||
    funnel.assigned != null ||
    funnel.marked != null
  ) {
    return true;
  }
  return false;
}
